"use client";
import Intro from "@/components/intro";
import { OFFERS_CONSTANTS } from "./constants";

const OffersComponent = () => {
  return <Intro {...OFFERS_CONSTANTS} />;
};

export default OffersComponent;
